/**
 * @file study
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'
import './index.scss'


class Study extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let introlist = [
      {
        img: '//cdn.ihatoo.com/hatu-official/course/f5-icon-ydy.png',
        title: '一对一课堂',
        intro: '根据你的学习需求，进行针对性指导，和老师一对一实时互动，享受VIP专属教学服务，短期快速突破。',
      },
      {
        img: '//cdn.ihatoo.com/hatu-official/course/f5-icon-jx.png',
        title: '精选小班课',
        intro: '匹配中文水平相近的小伙伴，利用同伴学习场景，建立浓厚的学习氛围，借助“榜样”力量，激发潜能，共同进步。',
      },
      {
        img: '//cdn.ihatoo.com/hatu-official/course/f5-icon-wh.png',
        title: '文化大讲堂',
        intro: '学习中华传统文化知识、习俗、礼仪，带你领略五千年的中华文化之美。',
      },
      {
        img: '//cdn.ihatoo.com/hatu-official/course/f5-icon-ss.png',
        title: '双师大课堂',
        intro: '基于哈兔的专业师资、严谨丰富的课程、稳定的在线教学平台支撑，以教室与学习者为中心为海外学校的学员提供纯正优质的中文课堂。',
      },

    ]
    return (
      <div id="course-study">
        <div className="inner-title">课堂形式</div>
        <div className="study-inner">

          <ul className="intro">
            {introlist.map((item, index) => (
              <li key={'intro-' + index}>
                <div className="img" style={{ background: `url(${item.img}) no-repeat center top` }}></div>
                <div className="title">{item.title}</div>
                <div className="intro">{item.intro}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default Study
